<template>

  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 135.479 49.911">
    <g id="Sedan" transform="translate(10739.479 525.345)">
      <path id="Path_87062" data-name="Path 87062"
        d="M47.161,178.954a10.073,10.073,0,1,0,0-20.145h0a10.073,10.073,0,1,0,0,20.145m0-17.8a7.709,7.709,0,0,1,5.421,13.179,7.644,7.644,0,0,1-5.433,2.242h-.026a7.711,7.711,0,0,1,.037-15.421"
        transform="translate(-10670.675 -654.389)" :fill="themeColor" />
      <path id="Path_87063" data-name="Path 87063"
        d="M17.57,178.954A10.073,10.073,0,1,0,7.493,168.883,10.084,10.084,0,0,0,17.57,178.954m-.006-17.8a7.711,7.711,0,1,1-7.709,7.729,7.72,7.72,0,0,1,7.709-7.729"
        transform="translate(-10725.609 -654.389)" :fill="themeColor" />
      <path id="Path_87064" data-name="Path 87064"
        d="M135.486,187.376c-.7-4.69-3.031-13.51-7.258-16.561a43.845,43.845,0,0,0-14.273-4.679,58.414,58.414,0,0,1-9.206-2.462c-1.791-.783-4.147-1.954-6.875-3.316a144.984,144.984,0,0,0-17.915-7.995c-7.021-3.113-17.743-3.976-27.5-3.976a206.205,206.205,0,0,0-22.885,1.351,1.178,1.178,0,0,0-.663.32l-10.354,9.848-12.9,1.625a1.182,1.182,0,0,0-.983.843L.063,178.345a1.163,1.163,0,0,0,0,.663c1.785,6.033,5.327,9.783,9.243,9.783h4.581a1.174,1.174,0,1,0,0-2.348H9.318c-2.591,0-5.241-2.882-6.752-7.344l-.143-.426,4.313-14.907,12.513-1.577a1.182,1.182,0,0,0,.663-.317l10.345-9.846.477-.054c5.713-.631,34.89-3.49,48.311,2.556a143.491,143.491,0,0,1,17.186,7.643l5.181,2.719-62.047-.3a1.175,1.175,0,0,0,.009,2.351l69.157.38c1.6.431,3.208.8,4.779,1.082a45.67,45.67,0,0,1,13.313,4.173c3.8,2.651,5.935,11.1,6.555,15.213a1.156,1.156,0,0,0,.486.683,1.177,1.177,0,0,0,1.822-1.1"
        transform="translate(-10739.493 -673.733)" :fill="themeColor" />
      <path id="Path_87065" data-name="Path 87065"
        d="M66.806,164.059h0a1.17,1.17,0,0,0,1.174-1.171,1.175,1.175,0,0,0-1.174-1.177H18A1.174,1.174,0,1,0,18,164.059Z"
        transform="translate(-10708.283 -649.002)" :fill="themeColor" />
    </g>
  </svg>

</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
